import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './components/generic/navbar/navbar.component';
import { environment } from '../environments/environment';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { HeaderTitleService } from './services/header-title.service';
import { NavigationStart } from '@angular/router';
import { filter } from 'rxjs';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    MatSidenavModule,
    MatIconModule,
    NgIf,
    MatButtonModule,
    MatListModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  router: Router = new Router();

  constructor(public headerTitleService: HeaderTitleService) {
    this.headerTitleService.title$.subscribe((t) => {
      this.title = t;
    });
  }

  title = this.headerTitleService.getTitle();
  currentApplicationVersion = environment.appVersion;
  isSidenavOpen = false;
  isLoggedIn = false;

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationStart))
      .subscribe((e) => {
        console.trace('Navigation triggered:', (e as NavigationStart).url);
      });
  }

  /**
   * navigates to ticket overview component
   */
  onpTicketsListClick(): void {
    this.router.navigate(['/pTickets/list']);
    this.isSidenavOpen = false;
  }

  /**
   * navigates to login component
   */
  onLoginClick(): void {
    this.router.navigate(['/login']);
    this.isSidenavOpen = false;
  }

  onAdministrationClick(): void {
    this.router.navigate(['/administration/panel']);
    this.isSidenavOpen = false
  }

  /**
   * routes to reporting map
   */
  onOpenReporting(): void {
    this.router.navigate(['/reporting/map']);
    this.isSidenavOpen = false;
  }

  onOpenReportingOverview(): void {
    this.router.navigate(['/reporting/overview']);
    this.isSidenavOpen = false;
  }
}
